import { useEffect } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

const positions = {};

const ScrollManager = () => {
  const location = useLocation();
  const navigationType = useNavigationType();

  useEffect(() => {
    const path = location.pathname + location.search;

    if (navigationType === "POP") {
      const savedPosition = positions[path];
      window.scrollTo(0, savedPosition ?? 0);
    } else {
      window.scrollTo(0, 0);
    }

    return () => {
      positions[path] = window.scrollY;
    };
  }, [location, navigationType]);

  return null;
};

export default ScrollManager;